import preloadedMessages from "./us.json";

export default {
    us: {
      name: "English",
      messages: preloadedMessages
    },
    es: {
      name: 'Spanish',
      load: () => { return import('./es.json'); },
    },
  };


// WEBPACK FOOTER //
// ./src/locales/translations/index.js